<template>
  <div class="edit-user-machine">
    <dialog-or-inline
      :embedded="embedded"
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="mcVerify"
      :title="biaoshi == 1 ? $t('machineConfig.plConfig') : $t('machineUser.mConfig')"
      :visible.sync="dialogConfigMachine"
      width="1140px"
      top="6vh"
      @open="openDialog"
      @closed="closeDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')" :class="{ 'cfg-embed': embedded }">
        <el-row style="margin-bottom: 20px; color: var(--vtm-crit)" v-if="biaoshi == 1">
          {{ $t("machineConfig.pTips") }}
        </el-row>
        <!-- 机器离线时密码下发不到机器，禁止修改管理员密码 -->
        <el-alert
          v-if="machineOffline"
          type="warning"
          show-icon
          :closable="false"
          :title="$t('configHelp.adminPasswordOffline')"
          style="margin-bottom: 16px"
        ></el-alert>
        <el-form :label-position="labelPosition" :rules="rules" ref="userEquipment" :label-width="embedded ? 'auto' : '80px'" :model="config">
          <!-- 管理员 -->
          <setting-section
            :title="$t('machineConfig.glyuan')"
            :help="$t('configHelp.administrator')"
          >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.merConfig')" prop="isOpen">
                <setting-switch v-model="config.manager.isOpen"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('configHelp.adminPasswordLabel')" prop="passWord">
                <el-input
                  v-model="config.manager.passWord"
                  :placeholder="$t('addUser.pePassword')"
                  autocomplete="off"
                  :disabled="machineOffline"
                  :class="{ 'cfg-input--warn': managerPwdIsDefault }"
                ></el-input>
                <!-- 出厂默认密码提醒：仅在该字段处提示 -->
                <div v-if="managerPwdIsDefault" class="cfg-field-warn">
                  <i class="el-icon-warning-outline"></i> {{ $t("machinesHub.defaultPasswordWarn") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.manager.isOpen == 1">
              <el-form-item :label="$t('editUserMachine.isDebug')" prop="isDebug">
                <setting-switch v-model="config.manager.isDebug"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.isCoupon')" prop="isCoupon">
                <setting-switch v-model="config.info.isCoupon"></setting-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 遥控器 -->
          <!-- <div
						style="height: 24px; line-height: 24px; display: flow-root; font-size: 15px; font-weight: 500; color: #000000; padding-left: 10px; border-left: 5px solid var(--color-primary); margin: 30px 0 5px 0; display: flex; align-items: center;"
					>
						{{ $t("machineConfig.yaokongqi") }}
					</div>
					<el-row :gutter="20">
						<el-col :span="6">
							<el-form-item
								:label="$t('editUserMachine.isRemoteControl')"
								prop="isBlue"
							>
								<setting-switch v-model="config.remote.isBlue"></setting-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="config.remote.isBlue > 0">
							<el-form-item
								:label="$t('editUserMachine.remoteLock')"
								prop="blueType"
							>
								<el-select
									v-model="config.remote.blueType"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in feelLock"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="6">
							<el-form-item
								:label="$t('editUserMachine.isFeelControl')"
								prop="isHaptic"
							>
								<setting-switch v-model="config.remote.isHaptic"></setting-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="config.remote.isHaptic > 0">
							<el-form-item
								:label="$t('editUserMachine.feelLock')"
								prop="hapticType"
							>
								<el-select
									v-model="config.remote.hapticType"
									filterable
									clearable
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('editUserMachine.pIsEnable')"
								>
									<el-option
										v-for="item in feelLock"
										:key="item.id"
										:label="item.label"
										:value="+item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row> -->

          <!-- 年龄识别：总开关放到标题行，开启后才显示识别设备与细项 -->
          </setting-section>
          <setting-section
            :title="$t('machineConfig.nlsb')"
            :help="$t('configHelp.ageIdentification')"
            toggleable
            v-model="config.age.isAge"
            @change="config.age.ageDevice = ''"
          >
          <el-row :gutter="20">
            <!-- 年龄识别选择范围 -->
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.331464-0')" prop="ageRange">
                <el-select
                  v-model="config.age.ageRange"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in ageRangeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="config.age.ageRange == 2">
              <el-form-item :label="$t('user.ConfigUserMachine.051200-0')" prop="ageNum">
                <el-input
                  v-model.number="config.age.ageNum"
                  :placeholder="$t('user.ConfigUserMachine.051200-1')"
                  autocomplete="off"
                  type="number"
                  min="0"
                  oninput="if(value < 0) value = 0"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 年龄识别设备选择 -->
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.nlsbsbxz')" prop="ageDevice">
                <el-select
                  v-model="config.age.ageDevice"
                  @change="handlerChangeIsAge"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('machineConfig.nlsbsbxz')"
                >
                  <el-option
                    v-for="item in ageDevice"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div style="color: var(--vtm-crit)" v-show="config.age.ageDevice == '1.4.1'">
                  {{ $t("machineConfig.yzjiage") }}0.23{{ $t("machineConfig.yzjiagec") }}
                </div>
                <div style="color: var(--vtm-crit)" v-show="config.age.ageDevice == '1.4.12'">
                  {{ $t("machineConfig.yzjiage") }}0.8{{ $t("machineConfig.yzjiagec") }}
                </div>
              </el-form-item>
            </el-col>
            <!-- 年龄识别sdk选择 -->
            <el-col v-if="config.age.ageDevice == 'MEPR500'" :span="6">
              <el-form-item :label="$t('editUserMachine.ageChooseSDK')" prop="ageSDK">
                <el-select
                  v-model="config.age.ageSDK"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.ageChooseSDK')"
                >
                  <el-option :label="$t('editUserMachine.aliSDK')" :value="1"></el-option>
                  <el-option :label="$t('editUserMachine.mySDK')" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- QRcode  mb 年龄识别 -->
          <template
            v-if="(config.age.ageDevice == '1.4.1' || config.age.ageDevice == '1.4.12')"
          >
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('machineConfig.isAgeCode')" prop="ageQrCode">
                  <setting-switch v-model="config.age.ageQrCode"></setting-switch>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('machineConfig.isAgeFace')" prop="isFace">
                  <setting-switch v-model="config.age.isFace"></setting-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('machineConfig.ageCount')" prop="ageCount">
                  <el-input
                    v-model="config.age.ageCount"
                    type="number"
                    :placeholder="$t('machineConfig.pAgeCount')"
                    autocomplete="off"
                  >
                    <template slot="append">{{ $t("user.ConfigUserMachine.578548-1") }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('machineConfig.faceSimilarity')" prop="faceSimilarity">
                  <el-input
                    v-model="config.age.faceSimilarity"
                    type="number"
                    :placeholder="$t('machineConfig.pFaceSimilarity')"
                    autocomplete="off"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <!-- ZQ年龄识别 -->
          <!-- <template
						v-if="config.age.ageDevice == 'ZQ'"
					>
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item
									:label="$t('machineConfig.isAgeCode')"
									prop="ageQrCode"
								>
									<setting-switch v-model="config.age.ageQrCode"></setting-switch>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item
									:label="$t('machineConfig.isFace')"
									prop="isAgeFace"
								>
									<setting-switch v-model="config.age.isAgeFace"></setting-switch>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item
									:label="$t('machineConfig.xjsbkg')"
									prop="ageCamera"
								>
									<setting-switch v-model="config.age.ageCamera"></setting-switch>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item
									:label="$t('machineConfig.yxsbfsxz')"
									prop="agePriority"
								>
									<el-select
										v-model="config.age.agePriority"
										filterable
										clearable
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										:placeholder="$t('editUserMachine.pIsEnable')"
									>
										<el-option
											v-for="item in priorityMode"
											:key="item.id"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</template> -->
          <!-- MEPR500年龄识别 -->
          <el-row v-if="config.age.ageDevice == 'MEPR500'" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isSecurity')" prop="isSecurity">
                <setting-switch v-model="config.age.isSecurity"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isAgeFace')" prop="isFace">
                <setting-switch v-model="config.age.isFace"></setting-switch>
              </el-form-item>
            </el-col>
            <template v-if="config.age.isFace == 1">
              <el-col :span="12">
                <el-form-item
                  :label="
                    $t('machineConfig.faceSimilarity') +
                    shibiePrice +
                    $t('machineConfig.dollar') +
                    $t('machineConfig.yzjiagec')
                  "
                  prop="faceSimilarity"
                >
                  <el-input
                    v-model="config.age.faceSimilarity"
                    type="number"
                    :placeholder="$t('machineConfig.pFaceSimilarity')"
                    autocomplete="off"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="display: none">
                <el-form-item :label="$t('machineConfig.yzjiage')" prop="faceSimilarity">
                  <el-input
                    value="0.007"
                    readyonly="readyonly"
                    type="number"
                    :placeholder="$t('machineConfig.pFaceSimilarity')"
                    autocomplete="off"
                  >
                    <template slot="append">{{ $t("machineConfig.yzjiagec") }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
          <!-- RK160年龄识别 -->
          <!-- <el-row
						v-if="config.age.ageDevice == 'RK160'"
						:gutter="20"
					>
						<el-col :span="12">
							<el-form-item
								:label="$t('machineConfig.isFace')"
								prop="isAgeFace"
							>
								<setting-switch v-model="config.age.isAgeFace"></setting-switch>
							</el-form-item>
						</el-col>
					</el-row> -->

          <el-row :gutter="20" style="width: 98%; margin: 20px 0 0 0px">
            <div style="margin-bottom: 10px; font-weight: bold">
              {{ $t("machineConfig.aratps") }}
            </div>
            <CustomDayTimePicker v-model="config.age.time" />
            <div style="margin-top: 6px; color: var(--vtm-crit)">
              {{ $t("machine.tishi") }}
            </div>
          </el-row>
          </setting-section>
          <!-- 光眼开光 -->
          <setting-section
            v-hasPerm="['usermahcine:hide:lighteye']"
            :title="$t('machineConfig.isEyes')"
            :help="$t('configHelp.refundSensor')"
          >
          <el-row :gutter="20" v-hasPerm="['usermahcine:hide:lighteye']">
            <el-col :span="10">
              <el-form-item :label="$t('machineConfig.isEye')">
                <setting-switch v-model="config.info.isEye"></setting-switch>
              </el-form-item>
            </el-col>
<!--            <el-col :span="18" style="padding-top: 50px">-->
<!--              <sqpan style="color: var(--vtm-crit)">{{ $t("machineConfig.closeEye") }}</sqpan>-->
<!--            </el-col>-->
          </el-row>
          <!-- 设备模式 -->
          </setting-section>
          <setting-section
            v-hasPerm="['usermahcine:hide:model']"
            :title="$t('machineConfig.sbmoshi')"
            :help="$t('configHelp.machineMode')"
          >
          <el-row v-hasPerm="['usermahcine:hide:model']" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.userDeviceMode')" prop="type">
                <el-select
                  v-model="config.model.type"
                  filterable
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pDeviceMode')"
                >
                  <el-option
                    v-for="item in deviceMode"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <block v-if="config.model.type == 1">
              <el-col :span="24" style="width: 98%; margin: 20px 0 0 0px">
                <div style="margin-bottom: 10px; font-weight: bold">{{ $t("user.ConfigUserMachine.891013-0") }}</div>
                <CustomDayTimePicker v-model="config.model.time" />
                <div style="margin-top: 6px; color: var(--vtm-crit)">
                  {{ $t("machine.tishi") }}
                </div>
              </el-col>
            </block>
            <block v-if="config.model.type == 2">
              <el-col :span="6">
                <el-form-item :label="$t('editUserMachine.tipTitle')" prop="title">
                  <el-input
                    v-model="config.model.title"
                    :placeholder="$t('editUserMachine.pTipTitle')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('editUserMachine.tipMessage')" prop="message">
                  <el-input
                    v-model="config.model.message"
                    :placeholder="$t('editUserMachine.pTipMessage')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </block>
            <!-- 新增 -->
            <block v-if="config.model.type == 3">
              <el-col :span="18">
                <el-form-item :label="$t('bigScreen.lCustomSp')" prop="tipPassword" style="max-width: 66%">
                  <el-select
                    v-model="config.model.lockPage"
                    filterable
                    clearable
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    :placeholder="$t('bigScreen.pChooseCustomSp')"
                  >
                    <el-option :key="1" :label="$t('bigScreen.adHome')" :value="1"></el-option>
                    <el-option :key="2" :label="$t('bigScreen.productHome')" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('editUserMachine.tipPassword')" prop="passWord">
                  <el-input
                    v-model="config.model.passWord"
                    :placeholder="$t('editUserMachine.pTipPassword')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('editUserMachine.tipMessage')" prop="message">
                  <el-input
                    v-model="config.model.message"
                    :placeholder="$t('editUserMachine.pTipMessage')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 时间段选择 -->
              <el-col :span="24" style="width: 98%; margin: 20px 0 0 0px">
                <div style="margin-bottom: 10px; font-weight: bold">
                  {{ $t("bigScreen.passwordSpTime") }}
                </div>
                <CustomDayTimePicker v-model="config.model.time" />
                <div style="margin-top: 6px; color: var(--vtm-crit)">
                  {{ $t("machine.tishi") }}
                </div>
              </el-col>
            </block>
          </el-row>
          <el-row v-hasPerm="['usermahcine:hide:model']" v-if="config.model.type == 2" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('editUserMachine.isTip')" prop="isPrompt">
                <setting-switch v-model="config.model.isPrompt"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$t('editUserMachine.userTipConfirm')" prop="confirm">
                <el-input
                  v-model="config.model.confirm"
                  :placeholder="$t('editUserMachine.puserTipConfirm')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$t('editUserMachine.userTipCancel')" prop="cancel">
                <el-input
                  v-model="config.model.cancel"
                  :placeholder="$t('editUserMachine.puserTipCancel')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 线上支付 -->
          </setting-section>
          <setting-section
            v-hasPerm="['usermahcine:hide:xspay']"
            :title="$t('machineConfig.xspay')"
            :help="$t('configHelp.onlinePayment')"
          >
          <el-row :gutter="20" v-hasPerm="['usermahcine:hide:xspay']">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.isSms')" prop="isSms">
                <setting-switch v-model="config.info.isSms"></setting-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 设备税率：总开关放到标题行，开启后才显示税率细项 -->
          </setting-section>
          <setting-section
            v-hasPerm="['user:machine:taexrat']"
            :title="$t('editUserMachine.vatRate')"
            :help="$t('configHelp.equipmentTaxRate')"
            toggleable
            v-model="config.vatRate.isOpen"
          >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item
                :label="$t('user.ConfigUserMachine.578548-0')"
                prop="config.vatRate.isOpen"
              >
                <el-select
                  v-model="config.vatRate.isCalculating"
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in vatRateIsHaveArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('editUserMachine.vatRateSet')">
                <el-select
                  v-model="config.vatRate.type"
                  clearable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option
                    v-for="item in vatRateSetArr"
                    :key="item.value"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="config.vatRate.type != 1" style="color: var(--vtm-crit); margin-top: 40px">
              {{ $t("editUserMachine.vatRateTips") }}
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="config.vatRate.isOpen == '1' && config.vatRate.type == 1" v-hasPerm="['user:machine:taexrat']">
            <el-col :span="24">
              <div class="vat-components">
                <div class="vat-components__row" v-for="(comp, idx) in config.vatRate.components" :key="idx">
                  <el-input
                    :placeholder="$t('editUserMachine.taxComponentName')"
                    v-model="comp.name"
                    style="width: 220px; margin-right: 8px"
                    @input="recomputeVatRate"
                  ></el-input>
                  <el-input :min="0" :max="100" type="number" v-model="comp.rate" style="width: 140px; margin-right: 8px" @input="recomputeVatRate">
                    <template #suffix> % </template>
                  </el-input>
                  <el-button type="text" icon="el-icon-delete" :disabled="config.vatRate.components.length <= 1" @click="removeVatComponent(idx)"></el-button>
                </div>
                <el-button size="small" plain icon="el-icon-plus" @click="addVatComponent">{{ $t("editUserMachine.taxComponentAdd") }}</el-button>
                <div class="vat-components__preview" v-if="(config.vatRate.components || []).length > 1">
                  {{ $t("editUserMachine.taxComponentPreview", { rate: config.vatRate.proportion || 0, example: vatRatePreviewExample }) }}
                </div>
              </div>
            </el-col>
          </el-row>
          </setting-section>
          <!-- 电子锁 -->
          <setting-section
            v-hasPerm="['usermahcine:hide:electroniclock']"
            :title="$t('machineConfig.electricLock')"
            :help="$t('configHelp.electronicLock')"
          >
          <el-row v-hasPerm="['usermahcine:hide:electroniclock']" :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isElectricLock')">
                <el-button v-if="!config.elock.isOpen" @click="handlerOpenElock" type="warning" size="small">
                  {{ $t("user.ConfigUserMachine.660097-0") }}
                </el-button>
                <el-button v-else @click="config.elock.isOpen = 0" type="danger" size="small">
                  {{ $t("user.ConfigUserMachine.660097-1") }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 购物提示：总开关放到标题行，开启后才显示提示文案 -->
          </setting-section>
          <setting-section
            :title="$t('machineConfig.gouwutishi')"
            :help="$t('configHelp.shoppingTips')"
            toggleable
            v-model="config.shopping.isTip"
          >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.shoppingTipTitle')" prop="tipTitle">
                <el-input
                  v-model="config.shopping.tipTitle"
                  :placeholder="$t('editUserMachine.pShoppingTipTitle')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.shoppingTipMessage')" prop="tipMessage">
                <el-input
                  v-model="config.shopping.tipMessage"
                  :placeholder="$t('editUserMachine.pShoppingTipMessage')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('editUserMachine.shoppingTipConfirm')" prop="tipConfirm">
                <el-input
                  v-model="config.shopping.tipConfirm"
                  :placeholder="$t('editUserMachine.pShoppingTipConfirm')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('editUserMachine.shoppingTipCancel')" prop="tipCancel">
                <el-input
                  v-model="config.shopping.tipCancel"
                  :placeholder="$t('editUserMachine.pShoppingTipCancel')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </setting-section>
          <!-- 购物车：总开关放到标题行，开启后才显示具体设置 -->
          <setting-section
            v-hasPerm="['usermahcine:hide:cart']"
            :title="$t('machineConfig.gouwuche')"
            :help="$t('configHelp.shoppingCart')"
            toggleable
            v-model="config.shopping.isCart"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('editUserMachine.cartNum')" prop="cartNum">
                  <el-input
                    v-model="config.shopping.cartNum"
                    :placeholder="$t('editUserMachine.pCartNum')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </setting-section>
          <!-- 故障处理 -->
          <setting-section
            :title="$t('machineConfig.gzchuli')"
            :help="$t('configHelp.troubleShooting')"
          >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('machineConfig.gbhuodao')" prop="isFaultClose">
                <setting-switch v-model="config.info.isFaultClose"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-hasPerm="['usermahcine:hide:islock']">
              <el-form-item :label="$t('editUserMachine.isLock')" prop="isFaultLock">
                <setting-switch v-model="config.info.isFaultLock"></setting-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 页面属性 -->
          </setting-section>
          <setting-section
            :title="$t('machineConfig.ymshuxing')"
            :help="$t('configHelp.advertisingSettings')"
          >
          <!-- 广告展示设置：飞出面板中改由「广告」页签承载，故 hideAdSettings 时隐藏此行 -->
          <el-row :gutter="20" style="margin-bottom: 0px" v-if="!hideAdSettings">
            <el-col :span="6">
              <el-form-item :label="$t('machineConfig.isPAd')" prop="isPAd">
                <setting-switch v-model="config.info.isPAd" :disabled="$tools.IsGrayModule('usermahcine:gray:ispad')"></setting-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="isTAd">
                <span slot="label" style="display: flex; flex-wrap: wrap">
                  <span>{{ $t("machineConfig.isTAd") }}</span>
                </span>
                <setting-switch v-model="config.info.isTAd" :disabled="$tools.IsGrayModule('usermahcine:gray:istad')"></setting-switch>
                <span style="color: var(--vtm-crit)">{{ $t("machineConfig.jzyfp") }}</span>
              </el-form-item>
            </el-col>

            <!-- {{ $t('user.ConfigUserMachine.966810-0') }} -->
            <el-col :span="6">
              <el-form-item v-if="config.info.isTAd == 1">
                <span slot="label" style="display: flex; flex-wrap: wrap">
                  <span>{{ $t("user.ConfigUserMachine.966810-0") }}</span>
                </span>
                <setting-switch v-model="config.advert.isCountdown"></setting-switch>
              </el-form-item>
            </el-col>
            <!-- {{ $t('user.ConfigUserMachine.966810-1') }} -->
            <el-col :span="6" v-if="config.info.isTAd == 1">
              <el-form-item :label="$t('user.ConfigUserMachine.966810-1')">
                <el-input v-model="config.advert.countdown" :placeholder="$t('user.ConfigUserMachine.966810-2')">
                  <template slot="append">s</template></el-input
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" v-hasPerm="['usermahcine:hide:isptag']">
              <el-form-item :label="$t('machineConfig.isPTag')">
                <setting-switch v-model="config.info.isPTag"></setting-switch>
              </el-form-item>
            </el-col>
            <!-- {{ $t('user.ConfigUserMachine.025933-0') }} -->
            <el-col :span="6">
              <el-form-item :label="$t('user.ConfigUserMachine.025933-0')">
                <el-input
                  v-model="config.info.moneySign"
                  :placeholder="$t('user.ConfigUserMachine.025933-1')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- {{ $t('user.ConfigUserMachine.444674-0') }}-->
            <el-col :span="6" v-hasPerm="['usermahcine:hide:isgoodsmode']">
              <el-form-item :label="$t('user.ConfigUserMachine.444674-0')">
                <setting-switch v-model="config.info.isGoodsMode"></setting-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </setting-section>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer cfg-footer">
        <span v-if="embedded && dirty" class="cfg-dirty"><i class="el-icon-warning-outline"></i> {{ $t("machinesHub.configDirty") }}</span>
        <el-button v-if="!embedded" @click="cancel('')" size="small">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" size="small" :disabled="loadingForm" @click="submitForm('userEquipment')">{{
          embedded ? $t("machinesHub.saveConfig") : $t("common.definite")
        }}</el-button>
      </div>
    </dialog-or-inline>
    <!-- 用户验证 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineConfig.yhyanz')"
      :visible.sync="dialogSmsVisible"
      width="305px"
      custom-class="SmsVerify"
      :before-close="handleVerifySmsClose"
      :close-on-click-modal="false"
    >
      <div>
        <p>{{ $t("machineConfig.yanztips") }}</p>
        <el-select v-model="verifyvalue" style="margin: 10px 0" size="small">
          <el-option
            v-for="(vers, index) in verifyset"
            :key="index"
            :label="vers['name']"
            :value="vers['value']"
          ></el-option>
        </el-select>
        <template v-if="issend">
          <p style="margin-top: 5px; color: var(--vtm-ok)">
            {{ $t("machineConfig.tips2") }}
          </p>
        </template>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <el-input
            v-model="smscode"
            maxlength="6"
            :placeholder="$t('machineConfig.psmsemail')"
            style="margin-right: 15px"
            size="small"
          ></el-input>
          <el-button
            v-if="smscode && issend"
            type="primary"
            size="small"
            @click="handlerVerifySms"
            :loading="smsloading"
            >{{ $t("machineConfig.yanzhen") }}</el-button
          >
          <template v-else>
            <el-button v-if="!issend" type="primary" size="small" @click="handlerSendSms" :loading="smsloading">{{
              $t("machineConfig.sendbtn")
            }}</el-button>
            <el-button v-else type="primary" size="small" disabled
              >{{ $t("machineConfig.sendbtn") }}({{ miao }}s)</el-button
            >
          </template>
        </div>
        <div style="margin-top: 15px; color: var(--vtm-crit); font-size: 12px">
          {{ $t("machineConfig.tips1") }}
        </div>
      </div>
    </el-dialog>
    <!-- 弹窗提示年龄识别扣费 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('user.ConfigUserMachine.879870-0')"
      :visible.sync="openIsAgeDialog"
      width="300px"
      :close-on-click-modal="false"
      center
    >
      <span>{{ $t("user.ConfigUserMachine.879870-1") }}</span>
      <span style="color: var(--vtm-crit)">${{ walletPrice }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handlerToRecharge">{{ $t("user.ConfigUserMachine.879870-2") }}</el-button>
        <el-button size="small" v-if="walletPrice >= 1" type="primary" @click="handlerContinueOpen">{{
          $t("user.ConfigUserMachine.879870-3")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomDayTimePicker from "@/components/CustomDayTimePicker.vue";
  import { isDefaultAdminPassword } from "@/utils/machineDefaults";
  import config from "@/http/config";
  import DialogOrInline from "./DialogOrInline";
  import SettingSwitch from "./SettingSwitch";
  import SettingSection from "./SettingSection";
  export default {
    name: "ConfigUserMachine",
    components: { CustomDayTimePicker, DialogOrInline, SettingSwitch, SettingSection },
    props: {
      dialogConfigMachine: Boolean,
      userEquipment: Object,
      yesNo: Array,
      ageDevice: Array,
      feelLock: Array,
      ageType: Array,
      priorityMode: Array,
      deviceMode: Array,
      biaoshi: Boolean,
      IdcardCountry: Array,
      embedded: { type: Boolean, default: false },
      // 隐藏广告展示设置（飞出面板中已迁移到「广告」页签，避免重复）
      hideAdSettings: { type: Boolean, default: false }
    },
    data() {
      return {
        // 所有配置
        config: {
          age: {
            time: []
          },
          elock: {},
          info: {},
          manager: {},
          model: {
            time: []
          },
          remote: {},
          shopping: {},
          vatRate: { components: [] }
        },
        verify: [],
        labelPosition: "top",
        loadingForm: false,
        dirty: false,
        ready: false,
        props: {
          label: "name",
          children: "zones"
        },

        count: 1,
        limit: 1,
        defaultCheckedKeys: [],
        uploadUrl: config.baseUrl + this.$url.IDard.cert,
        headers: {
          token: this.$cookies.get("token")
        },
        certImgList: [],
        //  开锁验证
        dialogSmsVisible: false,
        issend: false,
        smscode: "",
        smsloading: false,
        miao: 180,
        localIsElectricLock: "",
        verifyvalue: "",
        verifyset: [],
        shibiePrice: 0,
        vatRateSetArr: [
          {
            label: this.$t("editUserMachine.taxTyRateSet"),
            value: "1"
          },
          {
            label: this.$t("editUserMachine.taxDdRateSet"),
            value: "2"
          }
        ],
        vatRateIsHaveArr: [
          {
            label: this.$t("editUserMachine.taxInclude"),
            value: "0"
          },
          {
            label: this.$t("editUserMachine.taxunInclude"),
            value: "1"
          }
        ],
        userName: "",
        // 年龄识别应用范围
        ageRangeArr: [
          {
            value: "1",
            label: this.$t("user.ConfigUserMachine.331464-1")
          },
          {
            value: "2",
            label: this.$t("user.ConfigUserMachine.331464-2")
          }
        ],
        //钱包余额
        walletPrice: 0,
        openIsAgeDialog: false
      };
    },
    mounted() {
      this.handlerGetShibiePrice();
      this.userName = localStorage.getItem("userName");
    },
    watch: {
      // 仅用于标记「有未保存更改」，不触发自动保存
      config: {
        deep: true,
        handler() {
          if (this.ready) this.dirty = true;
        }
      }
    },
    computed: {
      vatRatePreviewExample() {
        const sample = 10;
        const rate = (this.config.vatRate.proportion || 0) / 100;
        if (Number(this.config.vatRate.isCalculating) === 0) {
          const included = sample - sample / (1 + rate);
          return this.$t("editUserMachine.taxComponentPreviewIncluded", {
            price: `$${sample.toFixed(2)}`,
            tax: `$${included.toFixed(2)}`
          });
        }
        return `$${sample.toFixed(2)} \u2192 $${(sample * (1 + rate)).toFixed(2)}`;
      },

      // 设备管理密码仍为出厂默认（VapeTM）→ 字段级提醒
      // 单台机器且明确离线（mqState 不为 1）；批量配置或状态未知时不拦截
      machineOffline() {
        const ue = this.userEquipment;
        return !this.biaoshi && !!ue && ue.mqState != null && ue.mqState !== "" && String(ue.mqState) !== "1";
      },
      managerPwdIsDefault() {
        return !!(this.config && this.config.manager && isDefaultAdminPassword(this.config.manager.passWord));
      }
    },
    methods: {
      // Named components (e.g. PST 20%, GST 5%) compound into one blended rate,
      // which is what is saved and used downstream.
      recomputeVatRate() {
        let running = 1;
        (this.config.vatRate.components || []).forEach(comp => {
          running *= 1 + (parseFloat(comp.rate) || 0) / 100;
        });
        this.config.vatRate.proportion = Math.round((running - 1) * 100 * 100) / 100;
      },
      addVatComponent() {
        if (!this.config.vatRate.components) {
          this.config.vatRate.components = [];
        }
        this.config.vatRate.components.push({ name: "", rate: 0 });
        this.recomputeVatRate();
      },
      removeVatComponent(idx) {
        this.config.vatRate.components.splice(idx, 1);
        this.recomputeVatRate();
      },
      // TEMPORARY: the backend does not persist vatRate.components yet, so the split is
      // remembered locally to survive a reload. Safe to delete once that field ships.
      vatComponentsStorageKey() {
        const machineKey = this.userEquipment && (this.userEquipment.equipmentNo || this.userEquipment.id);
        return machineKey ? `vtm_vatRateComponents_${machineKey}` : null;
      },
      saveVatComponentsLocally() {
        const key = this.vatComponentsStorageKey();
        if (!key) return;
        try {
          if (this.config.vatRate.components && this.config.vatRate.components.length > 1) {
            localStorage.setItem(key, JSON.stringify(this.config.vatRate.components));
          } else {
            localStorage.removeItem(key);
          }
        } catch (e) {}
      },
      restoreVatComponentsLocally() {
        const key = this.vatComponentsStorageKey();
        if (!key) return;
        try {
          const saved = JSON.parse(localStorage.getItem(key));
          if (!Array.isArray(saved) || saved.length === 0) return;
          let running = 1;
          saved.forEach(comp => {
            running *= 1 + (parseFloat(comp.rate) || 0) / 100;
          });
          const blended = Math.round((running - 1) * 100 * 100) / 100;
          if (Math.abs(blended - (this.config.vatRate.proportion || 0)) < 0.01) {
            this.config.vatRate.components = saved;
          }
        } catch (e) {}
      },

      handlerToRecharge() {
        this.$router.push("/mywallet/topup");
      },
      handlerContinueOpen() {
        this.config.age.isAge = 1;
        this.openIsAgeDialog = false;
      },
      handlerChangeIsAge(e) {
        console.log(e, "e");
        //AgeRecognitionScanner 年龄识别扫描器
        if (e != "AgeRecognitionScanner" && this.walletPrice < 10) {
          this.config.age.ageDevice = "";
          this.openIsAgeDialog = true;
        }
      },
      handlerGetShibiePrice() {
        this.$api.dict("face_accuracy").then(res => {
          if (res.data.length > 0) {
            this.shibiePrice = res.data[0].label;
          }
        });
      },
      isAdmin() {
        if (this.userName == "admin1") return true;
        return false;
      },
      handlerOpenElock() {
        const _self = this;
        
        // Direct unlock approach (no verification needed)
        let rData = {};
        
        // Check if it's a single equipment or group unlock
        if (_self.userEquipment.equipmentNo) {
          rData.equipmentNo = _self.userEquipment.equipmentNo;
        } else {
          rData.teamId = _self.userEquipment.id;
        }
        
        // Show loading state
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.request") || "Processing...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        
        // Call the direct unlock API
        _self.$api
          .request(_self.$url.UserMachine.electricLockDirect, _self.$method.post, rData)
          .then(res => {
            loading.close();
            if (parseInt(res.code) === 0) {
              _self.config.elock.isOpen = 1;
              _self.$notify({
                title: _self.$t("common.tip"),
                message: _self.$t("common.success") || "Electronic lock opened successfully",
                type: "success"
              });
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg || "Failed to unlock",
              type: "error"
            });
          });
      },
      handlerSendSms() {
        let _self = this;
        let verifyset = _self.verifyset;
        let verifytype = "";
        for (let i = 0; i < verifyset.length; i++) {
          if (_self.verifyvalue == verifyset[i]["value"]) {
            verifytype = verifyset[i]["type"];
          }
        }
        _self.smsloading = true;
        let rData = {
          equipmentNo: _self.userEquipment.equipmentNo,
          type: verifytype,
          verify: _self.verifyvalue
        };
        // 设备分组批量改
        if (rData.equipmentNo == "") {
          rData.teamId = _self.userEquipment.id;
          delete rData.equipmentNo;
        }
        _self.$api
          .request(_self.$url.UserMachine.getCode, _self.$method.post, rData)
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.issend = true;
              let dsq = window.setInterval(function () {
                if (_self.miao <= 1) {
                  window.clearInterval(dsq);
                  _self.issend = false;
                  _self.miao = 180;
                  return false;
                }
                _self.miao = parseInt(_self.miao) - 1;
                if (_self.miao < 10) {
                  _self.miao = "0" + _self.miao;
                }
              }, 1000);
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handlerVerifySms() {
        let _self = this;
        if (!_self.smscode) {
          _self.$message({
            message: _self.$t("machineConfig.ppsmsemail"),
            type: "warning"
          });
          return false;
        }
        _self.smsloading = true;
        let rData = {
          equipmentNo: _self.userEquipment.equipmentNo,
          verify: _self.verifyvalue,
          code: _self.smscode,
          unLock: 1
        };
        // 设备分组批量改
        if (rData.equipmentNo == "") {
          rData.teamId = _self.userEquipment.id;
          delete rData.equipmentNo;
        }
        _self.$api
          .request(_self.$url.UserMachine.validCode, _self.$method.post, rData)
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.config.elock.isOpen = 1;
              _self.dialogSmsVisible = false;
              return false;
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handleVerifySmsClose() {
        let _self = this;
        _self.issend = false;
        _self.smscode = "";
        _self.smsloading = false;
        _self.miao = 180;
        _self.localIsElectricLock = "";
        _self.verifyvalue = "";
        _self.dialogSmsVisible = false;
      },
      openDialog() {
        if (!this.userEquipment || !this.userEquipment.config) return;
        this.dirty = false;
        this.ready = false;
        this.$nextTick(() => {
          this.ready = true;
        });
        // 设置配置 — merge server data with defaults so nested objects always exist
        const serverConfig = JSON.parse(JSON.stringify(this.userEquipment.config)) || {};
        this.config = {
          age:      Object.assign({ time: [], isAge: null, ageCamera: null, ageQrCode: null, agePriority: null, ageDevice: '', isAgeFace: null, ageCount: null, ageSDK: null, faceSimilarity: null, isSecurity: null, isFace: null, ageRange: null }, serverConfig.age),
          elock:    Object.assign({ isOpen: null }, serverConfig.elock),
          info:     Object.assign({ isPAd: null, isTAd: null, isPTag: null, isFaultClose: null, isCoupon: null, isEye: null, isPrivacy: null, privacy: '', isSms: null, isFaultLock: null, moneySign: '', isGoodsMode: null }, serverConfig.info),
          manager:  Object.assign({ isOpen: null, isDebug: null, passWord: '' }, serverConfig.manager),
          model:    Object.assign({ type: null, lockPage: null, isPrompt: null, title: '', message: '', confirm: '', cancel: '', passWord: '', time: [] }, serverConfig.model),
          remote:   Object.assign({ isBlue: null, blueType: null, isHaptic: null, hapticType: null }, serverConfig.remote),
          shopping: Object.assign({ isTip: null, tipTitle: '', tipMessage: '', tipConfirm: '', tipCancel: '', isCart: null, cartNum: null }, serverConfig.shopping),
          vatRate:  Object.assign({ isOpen: null, isCalculating: null, type: null, proportion: null, components: [] }, serverConfig.vatRate),
          advert:   Object.assign({ isCountdown: null, countdown: '' }, serverConfig.advert),
        };
        // Always at least one tax row — a single row is exactly today's flat-rate
        // behaviour; seed it from the saved proportion so nothing is lost on first load.
        if (!this.config.vatRate.components || this.config.vatRate.components.length === 0) {
          this.config.vatRate.components = [{ name: "", rate: this.config.vatRate.proportion || 0 }];
        }
        this.restoreVatComponentsLocally();
        //钱包余额赋值
        if (this.userEquipment.walletPrice) {
          this.walletPrice = this.userEquipment.walletPrice;
        } else {
          this.walletPrice = 0;
        }
        // 填充时间
        if (!this.config.age.time || this.config.age.time.length <= 0) {
          this.config.age.time = this.handlerFillTime();
        }
        if (!this.config.model.time || this.config.model.time.length <= 0) {
          this.config.model.time = this.handlerFillTime();
        }
        this.verify = JSON.parse(JSON.stringify(this.userEquipment.verify || []));
      },
      handlerFillTime() {
        let arr = [];
        for (let i = 0; i < 336; i++) {
          let week = Math.floor(i / 48) + 1; // 7 days × 48 slots = 336
          let slotInDay = i % 48;
          let hour = Math.floor(slotInDay / 2);
          let startMinute = (slotInDay % 2) * 30;
          let endMinute = startMinute + 29;
          let start = `${("0" + hour).slice(-2)}:${("0" + startMinute).slice(-2)}:00`;
          let end = `${("0" + hour).slice(-2)}:${("0" + endMinute).slice(-2)}:59`;
          arr.push({
            start: start,
            end: end,
            week: week
          });
        }
        return arr;
      },
      closeDialog() {
        this.clearValidate("userEquipment");
        this.cancel("");
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          console.log(this.userEquipment);
          if (valid) {
            //  人脸识别精准度
            // if ((this.config.age.faceSimilarity < 1 || this.config.age.faceSimilarity > 100) && this.biaoshi != 1) {
            //   this.$notify({
            //     title: this.$t("common.tip"),
            //     message: this.$t("machineConfig.jzczzs"),
            //     type: "warning"
            //   });
            //   return false;
            // }

            let tjInfo = JSON.parse(JSON.stringify(this.userEquipment));
            tjInfo.config = JSON.parse(JSON.stringify(this.config));
            // 在线状态只用于界面判断，不能随配置回写（会覆盖机器真实的 mq_state）
            delete tjInfo.mqState;
            // 离线时保持原管理员密码，不下发修改
            if (this.machineOffline) {
              const orig = this.userEquipment.config && this.userEquipment.config.manager;
              tjInfo.config.manager.passWord = orig ? orig.passWord : tjInfo.config.manager.passWord;
            }
            // 如果全选传[]
            if (tjInfo.config.age.time?.length >= 336) {
              tjInfo.config.age.time = [];
            }
            if (tjInfo.config.model.time?.length >= 336) {
              tjInfo.config.model.time = [];
            }

            // 时间段判空
            if (!tjInfo.config.age.time) {
              tjInfo.config.age.time = [];
            }
            if (!tjInfo.config.model.time) {
              tjInfo.config.model.time = [];
            }

            // request
            let url = "";
            if (this.biaoshi == 1) {
              //  批量配置设备
              url = this.$url.UserMachine.gmodify;
            } else {
              //  单设备配置
              url = this.$url.UserMachine.modify;
            }
            this.loadingForm = true;
            this.$api
              .request(url, this.$method.put, tjInfo)
              .then(res => {
                if (res.code === 0) {
                  this.saveVatComponentsLocally();
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("editUserMachine.up"),
                    type: "success"
                  });
                  this.dirty = false;
                  this.cancel("update");
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      },
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      }
    }
  };
</script>

<style lang="scss" scoped>
  /* 出厂默认密码：字段级提醒 */
  .cfg-input--warn ::v-deep .el-input__inner {
    border-color: var(--vtm-warn);
    background: var(--vtm-warn-soft);
  }
  .cfg-field-warn {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.45;
    color: var(--vtm-warn);

    i {
      margin-right: 3px;
    }
  }
  /* 分区说明文字：每个分区标题下方的一行小字提示 */
  .cfg-help {
    font-size: 12px;
    color: var(--vtm-ink-3);
    margin: -2px 0 10px 10px;
    line-height: 1.45;
  }

  /* 内嵌（飞出页签）模式：单列、对齐、不溢出，配置更清晰易读 */
  .cfg-embed ::v-deep {
    .el-row {
      margin: 0 !important;
    }
    .el-col {
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      padding: 0 !important;
    }
    .el-form-item {
      margin-bottom: 16px !important;
    }
    .el-form-item__label {
      white-space: normal;
      line-height: 1.4;
      color: var(--vtm-ink-2);
      font-weight: 600;
      padding: 0 0 2px;
    }
    .el-select,
    .el-input,
    .el-input-number {
      width: 100%;
    }
    /* 宽的周×时段矩阵：横向滚动而非撑破布局 */
    .custom-day-time-picker,
    .day-time-picker,
    table {
      max-width: 100%;
      overflow-x: auto;
      display: block;
    }
  }
  .cfg-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }
  .cfg-dirty {
    margin-right: auto;
    font-size: 12px;
    color: var(--vtm-warn);
  }

  ::v-deep .mcVerify {
    border-radius: 6px;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: var(--vtm-mint);
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
      word-break: break-word;
      white-space: normal;
      line-height: 1.4;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
  ::v-deep .SmsVerify {
    height: auto !important;
    .el-dialog__body {
      height: auto !important;
      padding: 20px;
    }
  }
  ::v-deep .mcVerify {
    max-height: 90vh !important;
    display: flex;
    flex-direction: column;
    .el-dialog__body {
      flex: 1;
      overflow-y: scroll;
      padding: 20px 10px 0 20px;
    }
  }
</style>
